import React, { Component } from 'react'
import { VerticalRow } from '../../utils/Grid'
import DiscountBox from '../../boxes/DiscountBox'
import { GA_ENHANCED_ECOMMERCE } from '../../../constants'
import styled from 'styled-components'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import { type DiscountsContainerProps } from './Types'

const DiscountRow = styled(VerticalRow)`
  display: -ms-flexbox;
  -ms-flex-direction: row;
  -ms-flex-pack: justify;
  -ms-flex-wrap: wrap;
`

export default class DiscountsContainer extends Component<DiscountsContainerProps> {
  componentDidMount () {
    this.props.googleAnalytics.event(GA_ENHANCED_ECOMMERCE.IMPRESSION_PAYLOAD)
  }

  componentDidUpdate () {
    this.props.googleAnalytics.event(GA_ENHANCED_ECOMMERCE.IMPRESSION_PAYLOAD)
  }

  render () {
    const {
      boxes,
      googleAnalytics,
      imageSize,
      utmParams
    } = this.props

    if (!boxes.length) {
      return null
    }

    return (
      <DiscountRow>
        {
          boxes.map((box, index) => {
            const {
              discount,
              guid,
              images,
              link,
              price,
              title
            } = box

            const utmLink = utmLinkGenerator.createLinkWithOriginalQuery(link, utmParams)

            return <DiscountBox
              key={guid}
              discount={discount}
              googleAnalytics={googleAnalytics}
              guid={guid}
              image={images[imageSize]}
              imageClass={`image-${imageSize}`}
              link={utmLink}
              position={index}
              price={price}
              title={title}
            />
          })
        }
      </DiscountRow>
    )
  }
}
